import { createFileRoute, redirect } from '@tanstack/react-router';

import { BUILDER_STEPS } from 'shared/consts';
import { routes } from 'shared/routes';

import { isBuilderStep, isStepAccessible, STEP_COMPONENTS, useCitationBuilderStore } from 'features/citation-builder';

export const Route = createFileRoute('/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/$step')({
  beforeLoad: ({ params }) => {
    // Unknown segment (typo, removed step) → bounce to the first step rather than 404.
    if (!isBuilderStep(params.step)) {
      throw redirect(routes.cbCampaignEditStep(params.id, params.campaignId, BUILDER_STEPS.SCAN));
    }

    // The parent `_edit` layout already seeded the store, so this is fresh here.
    const { maxStep, isFixStepSkipped } = useCitationBuilderStore.getState();

    // Campaigns that skip Fix have `maxStep` advanced past it, so the accessibility
    // check below would happily render `/edit/fix`. Bounce to Build instead — the
    // step that actually follows Scan in their flow.
    if (isFixStepSkipped && params.step === BUILDER_STEPS.FIX) {
      throw redirect(routes.cbCampaignEditStep(params.id, params.campaignId, BUILDER_STEPS.BUILD));
    }

    if (!isStepAccessible(params.step, maxStep)) {
      throw redirect(routes.cbCampaignEditStep(params.id, params.campaignId, maxStep));
    }
  },
  component: StepRoute
});

function StepRoute() {
  const { step } = Route.useParams();
  const StepComponent = isBuilderStep(step) ? STEP_COMPONENTS[step] : STEP_COMPONENTS[BUILDER_STEPS.SCAN];

  return <StepComponent />;
}
